export const adaptDIResumen = (disfagiaData) => {
    const { videodeglucionAdjunto, ...disfagiaRI } = disfagiaData?.disfagiaRI || {};

    return {
        ...disfagiaRI,
        videodeglucionAdjunto: videodeglucionAdjunto ? {
            contentType: videodeglucionAdjunto?.contentType,
            archivo: videodeglucionAdjunto?.archivo,
            extension: videodeglucionAdjunto?.extension,
            titulo: videodeglucionAdjunto?.titulo,
        } : null,
        dIDisfagiaARI: disfagiaRI?.dIDisfagiaARI?.map(x => x.idComboRIValorNavigation?.valor),
        dIAlimentacionActualRI: disfagiaRI?.dIAlimentacionActualRI?.map(x => x.idComboRIValorNavigation?.valor),
        dIHidratacionActualRI: disfagiaRI?.dIHidratacionActualRI?.map(x => x.idComboRIValorNavigation?.valor),
        traqueostomiaDI: disfagiaRI?.traqueostomia,
        comboRIValorKarnofskyDI: disfagiaRI?.idComboRIValorKarnofskyNavigation?.valor,
        comboRIValorControlPostural: disfagiaRI?.idComboRIValorControlPosturalNavigation?.valor,
        comboRIValorDenticion: disfagiaRI?.idComboRIValorDenticionNavigation?.valor,
        comboRIValorProtesis: disfagiaRI?.idComboRIValorProtesisNavigation?.valor,
        comboRIValorEvaluacionFonoaudiologica: disfagiaRI?.idComboRIValorEvaluacionFonoaudiologicaNavigation?.valor,
        comboRIValorModuloDisfagia: disfagiaRI?.idComboRIValorModuloDisfagiaNavigation?.valor,
        comboRIValorNadaPorBoca: disfagiaRI?.idComboRIValorNadaPorBocaNavigation?.valor,
        comboRIValorHidratacion: disfagiaRI?.idComboRIValorHidratacionNavigation?.valor,
        comboRIValorLiquidosEspesadosConConsistencia: disfagiaRI?.idComboRIValorLiquidosEspesadosConConsistenciaNavigation?.valor,
    }
}